import "./CertificatePolicy.css";

function CertificatePolicy() {
  return (
    <div className="lp-page">

      <div className="lp-hero">
        <div className="lp-hero-tag">🎓 Certificates</div>
        <h1>Certificate Policy</h1>
        <p>
          Learnlia certificates recognize real course completion —
          here's how they work and what they represent.
        </p>
      </div>

      <div className="lp-container">
        <div className="lp-meta">
          <span>Last updated: March 2025</span>
          <span className="lp-meta-dot" />
          <span>Learnlia</span>
        </div>

        <div className="lp-section">
          <h2>How Certificates Are Issued</h2>
          <p>
            A certificate is automatically generated when you complete all lessons
            in a course tracked through Learnlia. No manual request is needed —
            once your progress reaches 100%, your certificate is ready.
          </p>
          <p>Each certificate includes:</p>
          <ul>
            <li>Your full name</li>
            <li>The course title</li>
            <li>Date of completion</li>
            <li>A unique verifiable certificate ID</li>
          </ul>
        </div>

        <div className="lp-section">
          <h2>Downloading & Sharing</h2>
          <p>
            Certificates can be downloaded as a PDF and shared for personal or
            professional use — on your resume, LinkedIn, or portfolio.
            There is no expiry date on issued certificates.
          </p>
        </div>

        <div className="lp-section">
          <h2>Verification</h2>
          <p>
            Every certificate has a unique ID that can be verified at any time
            through Learnlia's certificate verification page. Anyone with the ID
            can confirm the certificate is genuine.
          </p>
          <div className="lp-callout">
            Certificate verification is publicly accessible — no account required
            to verify someone else's certificate.
          </div>
        </div>

        <div className="lp-section">
          <h2>What Certificates Represent</h2>
          <p>
            Learnlia certificates represent the completion of course content
            tracked through the Learnlia platform. They are a record of your
            learning effort and consistency.
          </p>
          <p>
            These certificates are <strong>not</strong> academic credentials,
            professional licenses, or formally accredited qualifications.
            They are evidence of self-directed learning and course completion.
          </p>
        </div>

        <div className="lp-section">
          <h2>Certificate Integrity</h2>
          <p>
            Certificates must not be altered, falsified, or misrepresented.
            Learnlia reserves the right to revoke certificates if fraudulent
            activity, manipulation of progress data, or misuse is detected.
          </p>
        </div>

        <div className="lp-section">
          <h2>Questions</h2>
          <p>
            For certificate-related questions, contact us at{" "}
            <a href="mailto:learnliadev@gmail.com" style={{ color: "var(--accent)" }}>
              learnliadev@gmail.com
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default CertificatePolicy;